import { render } from "./WeekCostsModal.vue?vue&type=template&id=6356c8c6&scoped=true"
import script from "./WeekCostsModal.vue?vue&type=script&lang=js"
export * from "./WeekCostsModal.vue?vue&type=script&lang=js"

import "./WeekCostsModal.vue?vue&type=style&index=0&id=6356c8c6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6356c8c6"]])

export default __exports__